import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`npm's full public dataset is available via the `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/misc/registry"
      }}>{`public registry`}</a>{`. Using CouchDB replication, you can get a full copy of all metadata, and it is acceptable within our terms of use to download copies of tarballs for inspection or experimentation.`}</p>
    <p>{`npm's `}<a parentName="p" {...{
        "href": "https://www.npmjs.com"
      }}>{`website`}</a>{` also has package metadata available. We allow this content to be indexed by commercial crawlers such as GoogleBot. At our discretion, we also allow experimental crawlers to access the site, as long as they keep their request velocity to 1 request per second or less. At that velocity, indexing all packages would take 3 days, so if you want a full copy of our metadata it is always going to be faster to access the data via replication, which takes only an hour or two to provide full data and will thereafter automatically stay in sync.`}</p>
    <p>{`If you do not wish to install CouchDB to manage replication, we provide `}<a parentName="p" {...{
        "href": "https://github.com/npm/concurrent-couch-follower"
      }}>{`open source software`}</a>{` that makes it easy to sync to the registry's public feed.`}</p>
    <p>{`If you attempt to access package metadata by high-velocity crawling of the npm website, we reserve the right to rate-limit or ban your IP, user-agent or both.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      